"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("./helpers");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var useConfigContext_1 = require("../useConfigContext/useConfigContext");
exports.useLocalDate = function (props) {
    var languageCode = useConfigContext_1.useConfigContext().languageCode;
    var value = props.value, outputFormat = props.outputFormat, inputFormat = props.inputFormat, fromNow = props.fromNow, timezone = props.timezone;
    var date = inputFormat ? moment_timezone_1.default(value, inputFormat) : moment_timezone_1.default(value);
    date.locale(helpers_1.shimLocals(languageCode || "en"));
    if (timezone) {
        date.tz(timezone);
    }
    if (!fromNow) {
        return date.format(outputFormat || "L");
    }
    else {
        return date.fromNow();
    }
};
